// import Vue from 'vue'
// import Router from 'vue-router'
// import Home from '@/components/Home.vue'
// Vue.use(Router)

// export default new Router({
//   routes: [
//     {
//       path: '/Home',
//       name: 'Home',
//       component: Home
//     },
//   ]
// })
import { createWebHistory, createRouter } from "vue-router";
const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/components/Home.vue'),
    // meta: { requiresAuth: true }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/components/test.vue'),
    // meta: { requiresAuth: true }
  },
  {
    path: '/testIndexedDB',
    name: 'testIndexedDB',
    component: () => import('@/components/testIndexedDB.vue'),
    // meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/components/Login.vue'),
    // meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/components/Register.vue'),
    // meta: { requiresAuth: false }
  },
  {
    path: '/contest',
    name: 'contest',
    component: () => import('@/components/Contest.vue'),
    // meta: { requiresAuth: true }
  },
  {
    path: '/videocenter',
    name: 'videocenter',
    component: () => import('@/components/VideoCenter.vue'),
    // meta: { requiresAuth: true }
  },
  {
    path: '/studyhome',
    name: 'studyhome',
    component: () => import('@/components/studyHome.vue'),
    // meta: { requiresAuth: true }
  },
  {
    path: '/indexedDB',
    name: 'indexedDB',
    component: () => import('@/components/indexedDB.vue')
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
